import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
`;

export const Text = styled.div`
  color: #646363;
  text-align: right;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  max-width: 150px;
`;
export const Preview = styled.img`
  height: 60px;
  width: 60px;
  margin-bottom: 4px;
  object-fit: contain;
`;
